<template>
  <div :class="classes" ref="grid">
        <!--网格项，应该放置一组同级的dom-->
        <slot />
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-grid'

export default {
  name: 'wt-grid',
  props: {
    // 列数，如果不指定，或指定为auto，将会自动往后追加
    col: {
      type: [Number, String],
      default: 1
    },
    // 行数，如果不指定，或指定为auto，将会自动往后追加
    row: {
      type: [Number, String],
      default: 1
    },
    // 行列间隔(等分)
    gridGap: {
      type: String,
      validator (val) {
        return /\d+(px|%|rem|em|vw|vh|vmax|vmin)$/.test(val)
      }
    },
    // 列间隔
    gridColumnGap: {
      type: String,
      validator (val) {
        return /\d+(px|%|rem|em|vw|vh|vmax|vmin)$/.test(val)
      }
    },
    // 行间隔
    gridRowGap: {
      type: String,
      validator (val) {
        return /\d+(px|%|rem|em|vw|vh|vmax|vmin)$/.test(val)
      }
    },
    // 排列方向,可用值['column','row']
    direction: {
      type: String,
      default: 'row',
      validator (val) {
        return val === 'column' || val === 'row'
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  methods: {
    render () {
      let grid = this.$refs.grid

      let unit = ''

      let colStr

      let rowStr

      let gridColumnGap

      let gridRowGap
      if (this.col > 1) {
        unit = '1fr'
      } else {
        unit = 'auto'
      }
      colStr = Array(Number(this.col)).fill(unit).join(' ')
      if (this.row > 1) {
        unit = '1fr'
      } else {
        unit = 'auto'
      }
      rowStr = Array(Number(this.row)).fill(unit).join(' ')
      if (this.gridGap || this.gridColumnGap) {
        gridColumnGap = this.gridColumnGap || this.gridGap
      }
      if (this.gridGap || this.gridRowGap) {
        gridRowGap = this.gridRowGap || this.gridGap
      }
      let style
      if (this.direction === 'row') {
        style = `
                    grid-auto-flow:${this.direction};
                    grid-template-columns:${colStr};
                    grid-auto-row:1fr;
                    grid-column-gap:${gridColumnGap};
                    grid-row-gap:${gridRowGap};
                `
      } else {
        style = `
                    grid-auto-flow:${this.direction};
                    grid-template-rows:${rowStr};
                    grid-auto-columns:1fr;
                    grid-column-gap:${gridColumnGap};
                    grid-row-gap:${gridRowGap};
                `
      }
      grid.style = style
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    col () {
      this.render()
    },
    row () {
      this.render()
    },
    gridGap () {
      this.render()
    },
    gridColumnGap () {
      this.render()
    },
    gridRowGap () {
      this.render()
    },
    direction () {
      this.render()
    }
  }
}
</script>

<style lang="less">
.wt-grid{
    display:grid;
}
</style>
